/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// libraries
import React, { Component } from 'react';
import { Container } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, shape, string, bool, number,
} from 'prop-types';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import qs from 'qs';
import Media from 'react-media';
import { connect } from 'react-redux';
import track from 'react-tracking';
import mbpLogger from 'mbp-logger';
import Cookies from 'universal-cookie';
import loadable from '@loadable/component';

// category buiilder ui components
import GraphqlDisclaimer from './Partials/GraphqlDisclaimer/GraphqlDisclaimer';
import SCIProductBannerUI from '../GraphqlCommonComponents/SCIBanners/SCIProductBannerUI';
import CategoryPageSkeleton from '../GraphqlSkeletonComponents/CategoryPageSkeleton/CategoryPageSkeleton';
import ProductCount from './Partials/ProductCount/ProductCount';

// helpers, redux, queries
import { trackPage, trackCategoryData } from '../../../helpers/tracking/common/commonTrackingHelpers';
import { getFeatureFlags, getDisplayDeliveryMethod } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import {
    getAddressSource, getSSRDeviceType, getIsBot, getDataDictionary,
} from '../../../../state/ducks/App/App-Selectors';
import { getPassportData } from '../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';
import { getBrand } from '../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { getLanguageName } from '../../../../state/ducks/Member/ducks/Auth/helper/helper';
import GraphqlMobileDesktopFacetsV2 from './Partials/GraphqlProductFacetsV2/GraphqlMobileDesktopFacetsV2';
import MobileDesktopFacetsV3 from './Partials/ProductFacetsV3/MobileDesktopFacetsV3';

const GraphqlLeftMenuContainer = loadable(() => import(/* webpackChunkName: "GraphqlLeftMenuContainer" */ './Partials/GraphqlLeftMenuContainer/GraphqlLeftMenuContainer'));
const RailMenuTabletContainer = loadable(() => import(/* webpackChunkName: "RailMenuTabletContainer" */ './Partials/RailMenuTabletContainer/RailMenuTabletContainer'));
const GraphqlProductContainer = loadable(() => import(/* webpackChunkName: "GraphqlProductContainer" */ './Partials/GraphqlProductContainer/GraphqlProductContainer'));
const GraphqlAfterProductBanner = loadable(() => import(/* webpackChunkName: "GraphqlAfterProductBanner" */ './Partials/GraphqlAfterProductBanner/GraphqlAfterProductBanner'));
const SCIImocUI = loadable(() => import(/* webpackChunkName: "SCIImocUI" */ '../GraphqlCommonComponents/SCIBanners/SCIImocUI'));
const GraphqlCatHeaderContainer = loadable(() => import(/* webpackChunkName: "GraphqlCatHeaderContainer" */ './Partials/GraphqlCatHeaderContainer/GraphqlCatHeaderContainer'));
const GraphqlBreadcrumbs = loadable(() => import(/* webpackChunkName: "GraphqlBreadcrumbs" */ '../GraphqlCommonComponents/GraphqlBreadcrumbs/GraphqlBreadcrumbs'));
const GraphqlProductFacets = loadable(() => import(/* webpackChunkName: "GraphqlProductFacets" */ './Partials/GraphqlProductFacets/GraphqlProductFacets'));
const FaqBlock = loadable(() => import(/* webpackChunkName: "FaqBlock" */ './Partials/FaqBlock/FaqBlock'));
const SeoBlock = loadable(() => import(/* webpackChunkName: "SeoBlock" */ '../../ContentTypeComponents/SeoBlock/SeoBlock'));
const GraphqlSeoHeadTags = loadable(() => import(/* webpackChunkName: "GraphqlSeoHeadTags" */ '../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags'));
const FilterDialog = loadable(() => import(/* webpackChunkName: "FilterDialog" */ './Partials/FilterDialog/FilterDialog'), {
    resolveComponent: (components) => components.FilterDialog,
});
const PlantsFilterDialog = loadable(() => import(/* webpackChunkName: "FilterDialog" */ './Partials/FilterDialog/PlantsFilterDialog'));

const styles = (theme) => ({
    leftMenu: {
        width: '100%',
        position: 'relative',
        [theme.breakpoints.up(420)]: {
            zIndex: '99',
        },
        [theme.breakpoints.up(769)]: {
            width: '260px',
            position: 'relative',
        },
        [theme.breakpoints.up(1025)]: {
            zIndex: '9',
        },
    },
    countAndSortContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        '& p': {
            fontSize: '14px',
        },
    },
    disableFacetLeftMenuTablet: {
        [theme.breakpoints.down(1025)]: {
            display: 'none',
        },
    },
    categoryContainer: {
        position: 'relative',
    },
    counterText: {
        color: theme.palette.primary.main,
    },
    fullWidthProductContainer: {
        width: '100%',
    },
    productContainer: {
        width: '100%',
        [theme.breakpoints.up(769)]: {
            width: ' calc(100% - 290px)',
            marginLeft: '30px',
        },
    },
    productContainerFood: {
        width: '100%',
        [theme.breakpoints.up(1025)]: {
            width: ' calc(100% - 290px)',
            marginLeft: '30px',
        },
    },
    categoryfooterContainer: {
        /* justifyContent: 'center', */
        padding: '35px 0 25px 0',
    },
    faqBlockContainer: {
        padding: '0 10px 25px 10px',
    },
    imocStyleBackground: {
        position: 'absolute',
        width: '100%',
        height: '100px',
        background: theme?.palette?.common?.lightPurple || '#f4f2f7',
    },
    siteContainer: {
        margin: '0 15px',
        maxWidth: '1400px',
        [theme.breakpoints.up(1430)]: {
            margin: '0 auto',
        },
        position: 'relative',
    },
    breadcrumbAndFilterContainer: {
        display: 'flex',
        alignItems: 'baseline',
        margin: '10px 0',
        flexWrap: 'wrap',
    },
    backTop: {
        textAlign: 'center',
        marginBottom: '40px',
        '& img': {
            background: theme?.palette?.colorPrimary,
            borderRadius: '50%',
            width: '35px',
            height: '34px',
            padding: '5px',
            display: 'block',
            margin: 'auto',
            marginBottom: '10px',
            cursor: 'pointer',
            '&:hover': {
                transform: 'translateY(-3px)',
                transition: 'all 0.5s ease',
            },
        },
        '& span': {
            textDecoration: 'underline',
            color: theme.palette.colorPrimary,
            cursor: 'pointer',
        },
    },
    plantsBackTop: {
        '& img': {
            background: theme?.palette?.common?.black,
        },
        '& span': {
            color: theme?.palette?.common?.black,
        },
    },
    productFacetsScrolling: {
        maxHeight: '90vh',
        overflowY: 'scroll',
        [theme.breakpoints.down(1025)]: {
            display: 'none',
        },
    },
    rightSection: {
        marginLeft: 'auto',
        display: 'flex',
        alignItems: 'center',
        minWidth: '255px',
    },
    frLang: {
        minWidth: '285px !important',
    },
});

// Send persist tracked category data
class GraphqlCategoryBuilder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterData: {},
            facetsData: this.getFacetsFromUrl(),
            imocHeight: 0,
            mobileGridLayout: false,
            productCount: 0,
        };
        this.onResize = this.onResize.bind(this);
    }

    componentDidCatch(jsError, reactInfo) {
        const { categoryData } = this.props;
        mbpLogger.logError({
            module: 'mbp-pwa-ui',
            message: `Unhandled error in Graphql Category Builder \n jsError = ${jsError} \n reactInfo = ${reactInfo} \n categoryData = ${categoryData}`,
            categoryData,
        });
    }

    getFacetsFromUrl = () => {
        const { history, featureFlags } = this.props;
        if (history.location?.search) {
            if (featureFlags['is-facet-throwing-error-resolver-enabled']) {
                try {
                    const decodedString = decodeURI(history?.location?.search).replace('?', '');
                    const queryParams = qs.parse(decodedString);
                    let redirectLocationData = queryParams.facet;
                    if (typeof queryParams.facet === 'string') {
                        redirectLocationData = [queryParams.facet];
                    }
                    const checkedFacetsData = redirectLocationData?.length && redirectLocationData?.[0] !== '' ? redirectLocationData : [];
                    return checkedFacetsData;
                } catch (e) {
                    mbpLogger.logError({
                        message: 'Malformed URI',
                        error: e,
                        module: 'useCheckedFacets',
                        function: 'useCheckedFacets',
                    });
                }
            } else if (history.location?.search) {
                const searchValue = unescape(history.location?.search);
                const locationData = searchValue?.includes('?facet=') ? searchValue.replace('?facet=', '') : '';
                const redirectLocationData = locationData?.split('&');
                const checkedFacetsData = redirectLocationData?.length && redirectLocationData?.[0] !== '' ? redirectLocationData : [];
                return checkedFacetsData;
            }
        }
        return [];
    }

    setFilterDataInCategoryBuilder = (data) => {
        this.setState({
            filterData: data,
        });
    }

    setFacetsDataInCollection = (facets) => {
        this.setState({
            facetsData: facets,
        });
    }

    scrollTop = () => {
        if (typeof window !== 'undefined') {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        }
    };

    passportUpSellLogic = (passportData) => {
        const cookies = new Cookies();
        if (passportData?.passport_up_sell_conditional_logic_at_entrance) {
            const { enable_cookie_value: enable } = passportData.passport_up_sell_conditional_logic_at_entrance;
            if (enable) {
                cookies.remove('passportUpSell');
                cookies.set('passportUpSell', true, {});
            } else {
                cookies.remove('passportUpSell');
            }
        }
    }

    imocHeightHandler = (calcHeight) => {
        if (calcHeight && calcHeight > 0) {
            this.setState({
                imocHeight: calcHeight,
            });
        }
    }

    setProductDisplayLayout = (layoutFlag) => {
        this.setState({
            mobileGridLayout: layoutFlag,
        });
    }

    loadProductFacets = (isFacetFiltersEnabled, isFoodBrand, classes, productFacetsBase, isFacetFiltersCountEnabled, filterFlag = true, category) => {
        const { trackEventAction } = this.props;
        return (isFacetFiltersEnabled && productFacetsBase?.length > 0) && filterFlag && (
            /* this is handling filter facets for food and floral */
            <div className={isFoodBrand
                ? classes.productFacetsScrolling
                : classes.productFacet}
            >
                <GraphqlProductFacets
                    category={category}
                    productFacets={productFacetsBase}
                    setFilterDataInCategoryBuilder={this.setFacetsDataInCollection}
                    isFoodBrand={isFoodBrand}
                    isFacetFiltersCountEnabled={isFacetFiltersCountEnabled}
                    track={trackEventAction}
                />
            </div>
        );
    }

    loadProductFacetsV2 = (isFoodBrand, productFacetsBase, isFacetFiltersCountEnabled, filterFlag, category, isFilterFacetsV2, isMobileFacetsV3, areDeliveryTypeFilterOptionsShown, abCategoryFilters) => {
        const {
            classes, trackEventAction, categoryData, abCategorySortAndFilter, featureFlags, presentation_family,
        } = this.props;
        const { productCount } = this.state;
        return (
            <GraphqlMobileDesktopFacetsV2
                isFoodBrand={isFoodBrand}
                classes={classes}
                productFacetsBase={productFacetsBase}
                isFacetFiltersCountEnabled={isFacetFiltersCountEnabled}
                filterFlag={filterFlag}
                category={category}
                trackEventAction={trackEventAction}
                categoryData={categoryData}
                abCategorySortAndFilter={abCategorySortAndFilter}
                isFilterFacetsV2={isFilterFacetsV2}
                isMobileFacetsV3={isMobileFacetsV3}
                featureFlags={featureFlags}
                displayDeliveryMethod={areDeliveryTypeFilterOptionsShown && abCategoryFilters !== 'hide'}
                setFacetsDataInCollection={this.setFacetsDataInCollection}
                setFilterDataInCategoryBuilder={this.setFilterDataInCategoryBuilder}
                presentation_family={presentation_family}
                productCount={productCount}
            />
        );
    }

    loadProductFacetsV3 = (isFoodBrand, productFacetsBase, isFacetFiltersCountEnabled, filterFlag, category, isDesktopFacetsV3, isMobileFacetsV3, areDeliveryTypeFilterOptionsShown, abCategoryFilters, ssrDeviceType) => {
        const {
            classes, trackEventAction, categoryData, abCategorySortAndFilter, featureFlags, presentation_family,
        } = this.props;
        const { productCount, facetsData } = this.state;

        return (
            <MobileDesktopFacetsV3
                selectedFacet={facetsData}
                isFoodBrand={isFoodBrand}
                classes={classes}
                productFacetsBase={productFacetsBase}
                isFacetFiltersCountEnabled={isFacetFiltersCountEnabled}
                filterFlag={filterFlag}
                category={category}
                trackEventAction={trackEventAction}
                categoryData={categoryData}
                abCategorySortAndFilter={abCategorySortAndFilter}
                isDesktopFacetsV3={isDesktopFacetsV3}
                isMobileFacetsV3={isMobileFacetsV3}
                featureFlags={featureFlags}
                displayDeliveryMethod={areDeliveryTypeFilterOptionsShown && abCategoryFilters !== 'hide'}
                setFacetsDataInCollection={this.setFacetsDataInCollection}
                setFilterDataInCategoryBuilder={this.setFilterDataInCategoryBuilder}
                presentation_family={presentation_family}
                openFacetDropdown={this.state.openFacetDropdown}
                setFacetLabel={this.setFacetLabel}
                productCount={productCount}
                ssrDeviceType={ssrDeviceType}
                productDisplayLayout={this.setProductDisplayLayout}
            />
        );
    }

    pullProductCount = (count) => {
        if (count) {
            this.setState({
                productCount: count,
            });
        }
    };

    isFacetV3AbEnabled = () => {
        const { history, abCategorySpecificFacets } = this.props;
        if (history?.location?.pathname && abCategorySpecificFacets?.type === 'variant' && (abCategorySpecificFacets?.list?.includes?.(history?.location?.pathname) || abCategorySpecificFacets?.list?.includes?.('all'))) {
            return true;
        }
        return false;
    }

    componentDidMount() {
        this.onResize();
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', () => {
                this.onResize();
            });
        }
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.onResize);
        }
    }

    onResize() {
        if (typeof window !== 'undefined') {
            this.setState({ isSmallScreen: window?.innerWidth <= 1024 });
        }
    }

    @track(trackCategoryData)
    render() {
        const {
            filterData, facetsData, imocHeight, mobileGridLayout, isSmallScreen,
        } = this.state;
        const {
            classes,
            featureFlags,
            displayDeliveryMethod,
            categoryData,
            pageData: {
                path,
            },
            presentation_family,
            addressSource,
            passportData,
            ssrDeviceType,
            isBot,
            brand,
            dataDictionary,
        } = this.props;
        const isFilterEnabled = featureFlags['is-sort-and-filter-collections-enabled'];
        const language = getLanguageName();
        const backToTop = 'back to the top';
        const defaultPageTitle = 'Plants Delivered to Your Door | Plants.com';
        if (categoryData !== undefined) {
            const {
                guidedNavForm, category, content, samedayCutoff,
            } = categoryData || null;
            // food brands
            const isFoodBrand = presentation_family === 'food';
            const productFacetsBase = category?.productFacets;
            const isFacetFiltersEnabled = featureFlags['is-facet-filters-enabled'];
            const productFacetsFood = productFacetsBase?.[0]?.entries?.length;
            const filterDialog = isFoodBrand ? '(min-width: 300px)' : '(min-width: 600px)';
            const [priceRangeData] = (productFacetsBase || [])?.filter((value) => value?.name?.toLowerCase() === 'price range');

            // const productContainerClass = isFoodBrand ? classes.productContainerFood : classes.productContainer;
            // cms entries
            let entries = [];
            if (content && content.entries) {
                entries = content.entries;
            }
            const [entriesData] = entries || {};
            const { seo } = entriesData || {};
            if (entriesData && !seo?.page_title) seo.page_title = entriesData?.name || defaultPageTitle;
            let { category_blocks } = entriesData || [];
            if (typeof category_blocks === 'undefined') {
                category_blocks = [];
            }
            // if exsists will render to page
            let disclaimerBlock;
            let bannerBlock;
            let faqBlock;
            category_blocks.forEach((block) => {
                if (block.banner) {
                    bannerBlock = block.banner;
                }
                if (block.disclaimer) {
                    disclaimerBlock = block.disclaimer;
                }
                if (block.faq) {
                    faqBlock = block;
                }
            });
            const isMobile = ssrDeviceType === 'mobile';
            const isDesktopFacetsV3 = false;
            this.passportUpSellLogic(passportData);
            // true if we have related_articles || block.related_searches || block.side_rail_banner
            const showLeftRailContent = category_blocks.some((block) => ((block.related_articles || block.related_searches || block.side_rail_banner)));
            const breadcrumbUI = () => {
                switch (brand?.code) {
                    case 'PLA':
                        return (
                            <Media
                                query={filterDialog}
                                render={() => (
                                    <div className={classes.breadcrumbAndFilterContainer}>
                                        {seo?.breadcrumb && <GraphqlBreadcrumbs brand={brand} breadCrumbArray={seo.breadcrumb} />}
                                    </div>
                                )}
                            />
                        );
                    default:
                        return (
                            <Media
                                query={filterDialog}
                                render={() => (
                                    <div className={classes.breadcrumbAndFilterContainer}>
                                        {seo?.breadcrumb && <GraphqlBreadcrumbs brand={brand} breadCrumbArray={seo.breadcrumb} />}
                                        <div className={`${classes.rightSection} ${language === '/fr' && classes.frLang}`}>
                                            {<ProductCount brand={brand} totalCount={categoryData?.category?.totalProducts} language={language} withFilter={!isFilterEnabled} />}
                                            {isFilterEnabled && category !== null && <FilterDialog featureFlags={featureFlags} displayDeliveryMethod={displayDeliveryMethod} setFacetsOptions={this.setFacetsDataInCollection} setFilterOptions={this.setFilterDataInCategoryBuilder} presentation_family={presentation_family} brand={categoryData?.brand} productFacets={productFacetsBase} setFilterDataInCategoryBuilder={this.setFilterDataInCategoryBuilder} language={language} />}
                                        </div>
                                    </div>
                                )}
                            />
                        );
                }
            };
            const filterUI = () => {
                const { history } = this.props;
                const { productCount } = this.state;

                const renderFacetUI = () => {
                    if (isMobile) {
                        return (
                            <Media
                                query="(max-width: 1024px)"
                                defaultMatches={ssrDeviceType !== 'desktop'}
                                render={() => this.loadProductFacetsV3(false, productFacetsBase, true, true, category, true, true, false, ssrDeviceType)}
                            />
                        );
                    }
                    return (
                        <>
                            <Media
                                style={{ display: 'sticky' }}
                                query="(min-width: 1025px)"
                                defaultMatches={ssrDeviceType === 'desktop'}
                                render={() => this.loadProductFacetsV3(false, productFacetsBase, true, true, category, true, true, false, ssrDeviceType)}
                            />
                            <PlantsFilterDialog featureFlags={featureFlags} displayDeliveryMethod={displayDeliveryMethod} setFacetsOptions={this.setFacetsDataInCollection} setFilterOptions={this.setFilterDataInCategoryBuilder} presentation_family={presentation_family} brand={categoryData?.brand} facetsData={facetsData} productFacets={productFacetsBase} setFilterDataInCategoryBuilder={this.setFilterDataInCategoryBuilder} history={history} totalCount={productCount} ssrDeviceType={ssrDeviceType} />
                        </>
                    );
                };

                switch (brand?.code) {
                    case 'PLA':
                        return (
                            <>
                                {renderFacetUI()}
                            </>
                        );
                    default:
                        return null;
                }
            };
            const backToTopArrow = () => {
                switch (brand?.code) {
                    case 'PLA':
                        return (
                            `${classes.backTop} ${classes.plantsBackTop}`
                        );
                    default:
                        return (
                            `${classes.backTop}`
                        );
                }
            };
            const categoryBodyUI = () => {
                const commonBodyUI = () => (
                    // eslint-disable-next-line react/jsx-wrap-multilines
                    <>
                        <div className={classes.siteContainer}>
                            {/* @intention:
                                    - render SCI imoc if we're on a SCI page
                                    - render standard category header for all other channels
                                */}
                            {(isMobile && brand?.code === 'PLA') ? (
                                <Media
                                    query="(max-width: 599px)"
                                    render={() => (
                                        <div className={classes.breadcrumbAndFilterContainer}>
                                            {seo?.breadcrumb && <GraphqlBreadcrumbs brand={brand} breadCrumbArray={seo?.breadcrumb} />}
                                        </div>
                                    )}
                                />
                            ) : null}
                            {(!isMobile && brand?.code === 'PLA') ? (
                                breadcrumbUI()
                            ) : null}
                            {(brand?.code === 'PLA') ? (
                                filterUI()
                            ) : null}
                            {addressSource === 'SCI' ? (
                                <SCIImocUI />
                            ) : (
                                <GraphqlCatHeaderContainer categoryHeader={category_blocks} brand={categoryData.brand} samedayCutoff={samedayCutoff} totalCount={category?.totalProducts} ssrDeviceType={ssrDeviceType} featureFlags={featureFlags} displayDeliveryMethod={displayDeliveryMethod} setFacetsOptions={this.setFacetsDataInCollection} setFilterOptions={this.setFilterDataInCategoryBuilder} presentation_family={presentation_family} productFacets={productFacetsBase} imocHeightHandler={this.imocHeightHandler} />
                            )}
                            {(!isMobile && brand?.code !== 'PLA') ? (
                                breadcrumbUI()
                            ) : null}
                            {(isMobile && brand?.code !== 'PLA') ? (
                                <Media
                                    query="(max-width:600px)"
                                    render={() => (
                                        <div className={classes.countAndSortContainer}>
                                            <FilterDialog featureFlags={featureFlags} displayDeliveryMethod={displayDeliveryMethod} setFacetsOptions={this.setFacetsDataInCollection} setFilterOptions={this.setFilterDataInCategoryBuilder} presentation_family={presentation_family} brand={categoryData?.brand} productFacets={productFacetsBase} setFilterDataInCategoryBuilder={this.setFilterDataInCategoryBuilder} language={language} />
                                            <ProductCount totalCount={categoryData?.category?.totalProducts} ssrDeviceType={ssrDeviceType} language={language} />
                                        </div>
                                    )}
                                />
                            ) : null}
                            {/*
                                        ___________________________________________________
                                        ___________________________________________________
                                        |                    |                              |
                                        |                    |                              |
                                        |    guidedNavForm   |                              |
                                        |      -AND/OR-      |                              |
                                        |  related_articles  |                              |
                                        |  related_searches  |   GraphqlProductContainer    |
                                        |  side_rail_banner  |                              |
                                        |        -OR-        |                              |
                                        |    FacetFilters    |                              |
                                        |                    |                              |
                                        |                    |                              |
                                        ___________________________________________________
                                        // TODO: make conditions into variables to reuse - mike
                                */}
                            <Grid container className={classes.categoryContainer}>
                                {(entriesData?.guided_nav?.show_guided_nav || showLeftRailContent || isFacetFiltersEnabled) ? (
                                    <Grid item className={`${classes.leftMenu} ${isFacetFiltersEnabled && isFoodBrand ? classes.disableFacetLeftMenuTablet : ''}`}>
                                        {/* flowers brands render only */}
                                        {((guidedNavForm?.entries?.length > 0) || showLeftRailContent) && (
                                            <GraphqlLeftMenuContainer
                                                guidedNavForm={guidedNavForm}
                                                leftMenuData={entriesData}
                                                isMobile={isMobile}
                                            />
                                        )}
                                        {/* food brands render only */}
                                        {(isFacetFiltersEnabled && isFoodBrand && productFacetsFood > 0) && (
                                            <div className={classes.productFacetsScrolling}>
                                                <GraphqlProductFacets
                                                    productFacets={productFacetsBase}
                                                    setFilterDataInCategoryBuilder={this.setFacetsDataInCollection}
                                                />
                                            </div>
                                        )}
                                    </Grid>
                                ) : null}
                                <Grid
                                    item
                                    className={`${(((guidedNavForm?.entries?.length > 0 && brand?.code !== 'PLA') || showLeftRailContent) || (isFacetFiltersEnabled && productFacetsFood > 0 && brand?.code !== 'PLA'))
                                        && (
                                            (isFoodBrand && brand?.code !== 'PLA' && brand?.code !== 'CAN')
                                                ? classes.productContainerFood
                                                : classes.productContainer
                                        )} ${classes.fullWidthProductContainer}`}
                                    id="productContainer"
                                >
                                    {addressSource === 'SCI'
                                        && <SCIProductBannerUI />}
                                    <GraphqlProductContainer
                                        path={path}
                                        initialProductData={categoryData?.category?.products}
                                        filterData={filterData}
                                        facetsData={facetsData}
                                        categoryData={categoryData}
                                        breadCrumbArray={seo?.breadcrumb}
                                        skipAddons={entriesData?.skip_add_ons === true}
                                        showMovieUpsell={entriesData?.show_movie_download_upsell && entriesData?.movie_download_upsell ? entriesData.movie_download_upsell : false}
                                        movieData={entriesData?.movie_download_upsell}
                                        showLeftRailContent={showLeftRailContent}
                                        priceRangeData={priceRangeData}
                                        isDesktopFacetsV3={isDesktopFacetsV3}
                                        pullProductCount={this.pullProductCount}
                                        mobileGridLayout={mobileGridLayout}
                                        isSmallScreen={isSmallScreen}
                                    />
                                </Grid>
                            </Grid>
                            {/* render only if data */}
                            {bannerBlock && (
                                <Grid>
                                    <GraphqlAfterProductBanner bannerBlock={bannerBlock} />
                                </Grid>
                            )}
                            {/* render only if data */}
                            {disclaimerBlock && (!isMobile || isBot) ? (
                                // render on screens >= 769
                                <Grid container className={classes.categoryfooterContainer}>
                                    <GraphqlDisclaimer disclaimerBlock={disclaimerBlock} />
                                </Grid>
                            ) : null}

                            {faqBlock && (!isMobile || isBot) ? (
                                // render on screens >= 769
                                <div className={classes.faqBlockContainer}>
                                    <FaqBlock faqBlock={faqBlock} />
                                </div>
                            ) : null}
                            {/* TO DO: Refactor  */}
                            {(isMobile && brand?.code !== 'PLA') ? (
                                <Media
                                    query="(max-width: 599px)"
                                    render={() => (
                                        <div className={classes.breadcrumbAndFilterContainer}>
                                            {seo?.breadcrumb && <GraphqlBreadcrumbs brand={brand} breadCrumbArray={seo?.breadcrumb} />}
                                        </div>
                                    )}
                                />
                            ) : null}
                        </div>
                    </>);
                switch (brand?.code) {
                    case 'PLA':
                        return (
                            <Container>
                                {commonBodyUI()}
                            </Container>
                        );
                    default:
                        return commonBodyUI();
                }
            };
            return (
                <>
                    <GraphqlSeoHeadTags seoData={seo} alternativeLang="true" />
                    <Media
                        query="(min-width:600px)"
                        render={() => (
                            brand?.code === 'CAN' && <div className={classes.imocStyleBackground} style={{ height: imocHeight }} />
                        )}
                    />
                    {categoryBodyUI()}
                    <div className={backToTopArrow()}>
                        <img role="presentation" onClick={this.scrollTop} alt="top-arrow" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDM0OS43NTcgMzQ5Ljc1NiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzQ5Ljc1NyAzNDkuNzU2OyINCgkgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8Zz4NCgkJPGc+DQoJCQk8Zz4NCgkJCQk8cGF0aCBkPSJNMjk4LjA1NSwxNDcuMTk5YzAsMi43ODctMS4yNjcsOS4yNzEtMTMuMDM2LDkuMjcxaC01NC4wMzd2MTc4Ljg1NmMwLjA3MiwwLjQ4LDAuMTQ0LDEuMTU5LDAuMTQ0LDEuOTM5DQoJCQkJCWMwLDMuMTc3LTEuMjA3LDYuMTA2LTMuNDE2LDguMjY5Yy0yLjg1OCwyLjc5OC03LjIyNCw0LjIyMi0xMi45ODgsNC4yMjJoLTgzLjA1NmMtMTEuNDkzLDAtMTQuNTI1LTguMTQ5LTE0LjUyNS0xMi40NTRWMTYwLjIzNg0KCQkJCQlINjcuNjA2Yy0xMy44NDEsMC0xNS45MDQtNi41OTQtMTUuOTA0LTEwLjUyMWMwLTYuMjkzLDUuOTk2LTEyLjU3Nyw3LjE5Ny0xMy43NzVjMy4xNzYtNC4zMDUsODkuMDM2LTExOC4xOTUsMTAxLjUyOS0xMzAuNzE4DQoJCQkJCWM0LjU1OC00LjUzNCw5LjEzMS01LjMzOSwxMi4xNjMtNS4yMDljNy4yOTMsMC4zLDEyLjI2OCw1LjkxNSwxMi44MDgsNi41NmwxMDQuODM4LDEyNi42NzQNCgkJCQkJQzI5MS43NSwxMzQuNjMxLDI5OC4wNTUsMTQxLjA2OCwyOTguMDU1LDE0Ny4xOTl6IiBmaWxsPSJ3aGl0ZSIvPg0KCQkJPC9nPg0KCQk8L2c+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo=" />
                        <span role="presentation" onClick={this.scrollTop}> {language === '/en' ? backToTop : dataDictionary[backToTop]} </span>
                    </div>
                    {(entriesData) ? (
                        <RailMenuTabletContainer
                            brand={brand}
                            railMenuData={entriesData}
                            isMobile={isMobile}
                        />
                    ) : null}
                    {categoryData?.content?.entries?.[0]?.seo_copy && <SeoBlock data={categoryData.content.entries[0].seo_copy} />}
                </>
            );
        }
        return <CategoryPageSkeleton />; // TODO Skeleton
    }
}

GraphqlCategoryBuilder.propTypes = {
    classes: object.isRequired,
    brand: shape({
        code: string,
    }).isRequired,
    categoryData: shape({
        content: object.isRequired,
        brand: string.isRequired,
        category: object.isRequired,
        guidedNavForm: object,
    }).isRequired,
    pageData: shape({
        path: string,
    }),
    featureFlags: object.isRequired,
    displayDeliveryMethod: bool.isRequired,
    presentation_family: string.isRequired,
    addressSource: string,
    passportData: shape({
        passport_up_sell_conditional_logic_at_entrance: shape({
            enable_cookie_value: bool,
            number_of_days_till_expiration: number,
        }),
    }),
    ssrDeviceType: string,
    isBot: bool.isRequired,
    dataDictionary: object.isRequired,
    history: object.isRequired,
    trackEventAction: object.isRequired,
    abCategorySortAndFilter: string.isRequired,
    abCategorySpecificFacets: object.isRequired,
};

GraphqlCategoryBuilder.defaultProps = {
    pageData: shape({
        path: '',
    }),
    addressSource: '',
    passportData: {},
    ssrDeviceType: '',
};

const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
    displayDeliveryMethod: getDisplayDeliveryMethod(state),
    addressSource: getAddressSource(state),
    passportData: getPassportData(state),
    ssrDeviceType: getSSRDeviceType(state),
    isBot: getIsBot(state),
    brand: getBrand(state),
    dataDictionary: getDataDictionary(state),
});

const enhance = compose(
    trackPage(),
    withStyles(styles),
    withRouter,
    connect(mapStateToProps),
);

export default enhance(GraphqlCategoryBuilder);
